
































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import cPopup from "@/components/default/Popup.vue";
import communicationRepository from "@/services/communicationRepository";
import settings from '@/settings.json';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxItem,
  DxLabel,
} from "devextreme-vue/form";
import { ReceiverType } from "@/data/web-api-client";

@Component({
  components: {
    cPopup,
    DxSimpleItem,
    DxForm,
    DxLabel,
    DxRequiredRule,
    DxItem,
  },
})
export default class CommunicationEmailPopup extends Vue {
  private communication: any = null;

  private show: boolean = false;
  private loading: boolean = false;
  private saving: boolean = false;
  private renderEmailUrl: string = "";

  ReceiverType: any = ReceiverType;

  public async Open(communication: any) {
    this.show = true;
    this.communication = communication;
    this.renderEmailUrl = settings.api + '/api' + `/Communications/RenderMail/${this.communication.id}`
  }

  public Close() {
    this.show = false;
  }

  private mounted() {
    this.loadData();
  }

  private async loadData() {}
}
